export const generateFlowChart = (policyText, title) => {
  const lines = policyText.split('\n').map(line => line.trim()).filter(line => line !== '');

  const numberedTitles = [];
  lines.forEach((line) => {
    const newLine = line.match(/^(\d+\.)\s+(.*)/);
    if (newLine) {
      numberedTitles.push(newLine[2]);
    }
  });

  const total = numberedTitles.length;
  const nodes = [
    {
      id: 'start',
      type: 'input',
      data: { label: <div className="text-sm font-bold">{title} Start</div> },
      position: { x: 250, y: 0 },
      style: {
        background: '#a3f7c0',
        color: '#333',
        padding: 10,
        borderRadius: '20px',
        border: '1px solid rgb(36, 25, 246)',
      },
    },
  ];

  const edges = [];

  // Define side-by-side pair for total 4 or 5 nodes
  let branchPair = null;
  if (total === 4 || total === 5 ) {
    const maxIndex = total - 2;
    const randomStart = Math.floor(Math.random() * maxIndex); 
    branchPair = [randomStart, randomStart + 1]; // indices of the pair
  }
   if (total === 6 ) {
    const Start = 0; 
    branchPair = [Start, Start + 1]; // indices of the pair
  }
  numberedTitles.forEach((title, index) => {
    const id = (index + 1).toString();
    const y = (index + 1) * 100;

    const isLast = index === total - 1;
    const isSecondLast = index === total - 2;
    const isInLastPair = total > 5 && (isLast || isSecondLast);
    const isInRandomBranch = branchPair && branchPair.includes(index);

    let x = 250;
    let nodeStyle = {
      background: 'var(--card-bg, white)',
      color: '#333',
      border: '1px solid rgb(36, 25, 246)',
      padding: 10,
      borderRadius: '10px',
      width: 'fit-content',
    };

    if (isInLastPair || isLast) {
      nodeStyle = {
        color: '#155724',
        border: '1px solid #ff0072',
        padding: 10,
        borderRadius: '10px',
        width: 'fit-content',
      };
      const baseY = (total - 2 + 1.2) * 100;
      x = isLast ? 370 : 50;
      nodes.push({
        id,
        type: 'output',
        data: { label: <div className="text-sm">{title}</div> },
        position: { x, y: baseY },
        style: nodeStyle,
      });
    }else if (isInLastPair || isSecondLast) {
      nodeStyle = {
        color: '#155724',
        border: '1px solid #ff0072',
        padding: 10,
        borderRadius: '10px',
        width: 'fit-content',
      };
      const baseY = (total - 2 + 1.5) * 100;
      x = isLast ? 370 : 130 +300;
      nodes.push({
        id,
        type: 'output',
        data: { label: <div className="text-sm">{title}</div> },
        position: { x, y: baseY },
        style: nodeStyle,
      });
    } else if (isInRandomBranch) {
      nodeStyle = {
        color: '#155724',
        border: '1px solid #ff0072',
        padding: 10,
        borderRadius: '10px',
        width: 'fit-content',
      };
      const baseY = (branchPair[0]+1) * 100;
      x = index === branchPair[1] ? 370 : 130;
      nodes.push({
        id,
        type: 'default',
        data: { label: <div className="text-sm">{title}</div> },
        position: { x, y: baseY },
        style: nodeStyle,
      });
    } else {
      nodes.push({
        id,
        type: isLast ? 'output' : 'default',
        data: { label: <div className="text-sm">{title}</div> },
        position: { x, y },
        style: nodeStyle,
      });
    }
  });

  // Edges
  if (nodes.length > 1) {
    edges.push({
      id: 'e-start-1',
      source: 'start',
      target: '1',
    });
  }

  for (let i = 0; i < total - 1; i++) {
    const from = (i + 1).toString();
    const to = (i + 2).toString();

    const isBeforeLastTwo = total > 5 && i === total - 3;
    const isBeforeRandomBranch = branchPair && i === branchPair[0] - 1;

    if (branchPair && branchPair[0] === 0) {
  // When branching is at the start (nodes 1 and 2)
  edges.push(
    {
      id: 'e-start-1',
      source: 'start',
      target: '1',
    },
    {
      id: 'e-start-2',
      source: 'start',
      target: '2',
      animated: true,
      style: { stroke: "#f6ab6c" },
    }
  );
} else {
  // Default single start edge
  edges.push({
    id: 'e-start-1',
    source: 'start',
    target: '1',
    // animated: true,
    // markerEnd: { type: 'arrowclosed' },
  });
}

for (let i = 0; i < total - 1; i++) {
  const from = (i + 1).toString();
  const to = (i + 2).toString();

  const isBeforeLastTwo = total > 5 && i === total - 3;
  const isBeforeRandomBranch = branchPair && i === branchPair[0] - 1;
  const isStartRandomBranch = branchPair && i === branchPair[0];
  const isAfterRandomBranch = branchPair && i === branchPair[1];

  if (isBeforeLastTwo) {
    edges.push(
      {
        id: `e${from}-${total - 1}`,
        source: from,
        target: (total - 1).toString(),
        type: 'step',
      },
      {
        id: `e${from}-${total}`,
        source: from,
        target: total.toString(),
        type: 'smoothstep',
        animated: true,
        style: { stroke: "#f6ab6c" },
      }
    );
    break;
  } else if (isBeforeRandomBranch) {
    edges.push(
      {
        id: `e${from}-${branchPair[0] + 1}`,
        source: from,
        target: (branchPair[0] + 1).toString(),
        animated: true,
      },
      {
        id: `e${from}-${branchPair[1] + 1}`,
        source: from,
        target: (branchPair[1] + 1).toString(),
        animated: true,
      }
    );
    i++; // Skip next as we're branching
  } else if (isAfterRandomBranch && i + 2 <= total) {
    // Node after the branch pair should get inputs from both
    edges.push(
      {
        id: `e${branchPair[0] + 1}-${to}`,
        source: (branchPair[0] + 1).toString(),
        target: to,
        animated: true,
      },
      {
        id: `e${branchPair[1] + 1}-${to}`,
        source: (branchPair[1] + 1).toString(),
        target: to,
        animated: true,
        style: { stroke: "#f6ab6c" },
      },
      {
        id: `e${branchPair[1] + 1}-${to}`,
        source: (branchPair[1] + 2).toString(),
        target:  (branchPair[1] + 3).toString(),
        
        animated: true,
        style: { stroke: "#f6ab6c" },
      }
    );
    i++; // Skip next as we manually linked both
  } else if (!isStartRandomBranch) {
    edges.push({
      id: `e${from}-${to}`,
      source: from,
      target: to,
      
      animated: i % 2 === 0,
    });
  }
  }
  }
  return { nodes, edges };
};


// export const generateFlowChart = (policyText, title) => {
//   // Split the input into lines and normalize whitespace
//   const lines = policyText.split('\n').map(line => line.trim()).filter(line => line !== '');

//   const numberedTitles = [];

//   lines.forEach((line) => {
//     const newLine = line.match(/^(\d+\.)\s+(.*)/);
//     if (newLine) {
//       const title = newLine[2];
//       numberedTitles.push(title);
//     }
//   });
// console.log(numberedTitles)

 
//   const nodes = [
//     {
//       id: 'start',
//       type: 'input',
//       data: {
//         label: (
//           <div className="text-sm font-bold">{title} Start</div>
//         ),
//       },
//       position: { x: 250, y: 0 }, // Start at the top
//       style: {
//         background: '#a3f7c0',
//         color: '#333',
//         padding: 10,
//         borderRadius: '20px', 
//         border:'1px solid rgb(36, 25, 246)',
//       },
//     },
//   ];

//   // Add nodes for each numbered title
//   numberedTitles.forEach((title, index) => {
//   const id = (index + 1).toString();
//   const isLast = index === numberedTitles.length - 1;
//   const isSecondLast = index === numberedTitles.length - 2;
//   const moreThanFour = numberedTitles.length > 4;

//   const y = (index + 1) * 100;

//   let nodeStyle = {
//     background: 'var(--card-bg, white)',
//     color: '#333',
//     border: '1px solid rgb(36, 25, 246)',
//     padding: 10,
//     borderRadius: '10px',
//   };

//   if (moreThanFour && isLast ) {
//     nodeStyle = {
//       //background: '#d4edda', // light green background for last two
//       color: '#155724',       // darker text
//       border: '1px solid #ff0072', // green border
//       padding: 10,
//       borderRadius: '10px',
//     };
//     const baseY = (numberedTitles.length - 2 + 1.2) * 100;
//       const xOffset = isLast ? 370 : 130; // left and right
//       nodes.push({
//         id,
//         type: 'output',
//         data: { label: <div className="text-sm">{title}</div> },
//         position: { x: xOffset, y: baseY },
//         style: nodeStyle,
//       });
//   }else if(moreThanFour && isSecondLast){
//     nodeStyle = {
//       //background: '#f7c1d9', // light green background for last two
//       color: '#155724',       // darker text
//       border: '1px solid #ff0072', // green border
//       padding: 10,
//       borderRadius: '10px',
//     };
//     const baseY = (numberedTitles.length - 2 + 1.5) * 100;
//       const xOffset = isLast ? 370 : 130; // left and right
//       nodes.push({
//         id,
//         type: 'output',
//         data: { label: <div className="text-sm">{title}</div> },
//         position: { x: xOffset, y: baseY },
//         style: nodeStyle,
//       });

//   } else if (isLast) {
//     nodeStyle.background = '#fae4cf'; // original background for last if only one special
//   }else {
//       // Normal layout
//       nodes.push({
//         id,
//         type: isLast ? 'output' : 'default',
//         data: { label: <div className="text-sm">{title}</div> },
//         position: { x: 250, y },
//         style: nodeStyle,
//       });
//     }
// });


//   // Generate edges
//   const edges = [];
//   // Connect start node to the first numbered node
//   if (nodes.length > 1) {
//     edges.push({
//       id: 'e-start-1',
//       source: 'start',
//       target: '1',
//       type: 'smoothstep',
//       animated: true,
//       // label: 'Begin',
//       // background: 'transparent',
//       // labelStyle: { fill: '#555', fontWeight: 500 },
//       markerEnd: { type: 'arrowclosed' },
//     });
//   }
//   // Connect numbered nodes sequentially
//   for (let i = 0; i < numberedTitles.length - 1; i++) {
//   const isBeforeLastTwo = i === numberedTitles.length - 3;
//   const moreThanFour = numberedTitles.length > 4;

//   if (moreThanFour && isBeforeLastTwo) {
//     // Connect third-last node to both of the last two nodes
//     edges.push(
//       {
//         id: `e${i + 1}-${i + 2}`,
//         source: (i + 1).toString(),
//         target: (i + 2).toString(),
//         type: 'smoothstep',
//         animated: i % 2 === 0,
//         labelStyle: { fill: '#555', fontWeight: 500 },
//         //markerEnd: { type: 'arrowclosed' },
//       },
//       {
//         id: `e${i + 1}-${i + 3}`,
//         source: (i + 1).toString(),
//         target: (i + 3).toString(),
//         type: 'smoothstep',
//         animated: true,
//         labelStyle: { fill: '#555', fontWeight: 500 },
//         style: { stroke: "#f6ab6c" },
//       }
//     );

//     // Skip the last two links to avoid linear connections
//     break;
//   } else {
//     edges.push({
//       id: `e${i + 1}-${i + 2}`,
//       source: (i + 1).toString(),
//       target: (i + 2).toString(),
//       type: 'smoothstep',
//       animated: i % 2 === 0,
//     });
//   }
// }


//   return { nodes, edges };
// };
